import { SVGProps } from 'react';

const Forklift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 12H5a2 2 0 0 0-2 2v5m0 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m8 0a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0 0H8m8-17v17h6M6 12V7c0-1.1.9-2 2-2h3l5 5"
    />
  </svg>
);
export default Forklift;
